import { useMemo } from 'react';

/**
 * Custom hook for citation text formatting
 * Handles URL decoding and text truncation with memoization
 *
 * @param {string} text - Text to format (URL-encoded or plain)
 * @param {number} maxLength - Maximum length before truncation (default: 60)
 * @returns {string} Formatted and optionally truncated text
 */
export function useCitationFormatting(text, maxLength = 60) {
  return useMemo(() => {
    if (!text) return '';

    // Decode URL-encoded characters for better readability
    let decoded;
    try {
      decoded = decodeURIComponent(text.replace(/\+/g, ' '));
    } catch (e) {
      // If decoding fails, use original text
      decoded = text;
    }

    // Truncate if too long
    if (maxLength !== Infinity && decoded.length > maxLength) {
      return decoded.substring(0, maxLength) + '...';
    }

    return decoded;
  }, [text, maxLength]);
}
